mutation startRegeneration($companyId: ID!) {
  startRegeneration(companyId: $companyId)
}
